// Not used directly, this is just combining null and undefined for us

// used similarly to `Maybe` found in this repo

// typeguards to ensure values are defined or not
export const isNone = nullable => nullable === null || nullable === undefined;
export const isSome = nullable => !isNone(nullable);